<template>
  <div class="body">
    <div class="title">
      意见反馈
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf">
            首页
          </span></el-breadcrumb-item>
          <el-breadcrumb-item>信息管理</el-breadcrumb-item>
          <el-breadcrumb-item>意见反馈</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="btnsearch">
      <div class="left">
        <button size="medium" @click="openccsss" class="btnss">
          <i class="el-icon-check"></i>
          批量受理</button>
      </div>
      <div class="right">
        <el-form :inline="true">
          <el-form-item>
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              v-model="Query.create_date"
              @change="Discountsearch"
              placeholder="提交日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select  placeholder="排序"  v-model="Query.sortby"  @change="Discountsearch" style="min-width: 168px;width: 168px" clearable>
              <el-option  name="selected" :value="1" label="受理时间倒序 "></el-option>
              <el-option  name="selected" :value="0" label="提交时间倒序 "></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select  placeholder="受理状态" v-model="Query.sortby"  @change="Discountsearch"  style="min-width: 168px;width: 168px" clearable>
              <el-option  name="selected" :value="0" label="全部 "></el-option>
              <el-option  name="selected" :value="2" label="已受理 "></el-option>
              <el-option  name="selected" :value="1" label="待受理 "></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="反馈信息" style="min-width: 168px;width: 336px;" v-model="Query.keyword"  @change="Discountsearch">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-table
      :stripe="true"
      :data="tableData"
      max-height="750"
      class="mytable-scrollbar"
      ref="EditUsertable"
      @selection-change="EdithandleSelectionChange"
      :row-key="(row) => row.id">
      <el-table-column
        type="selection"
        :reserve-selection="true"
      >
      </el-table-column>
      <el-table-column
        prop="id"
        label="ID"
      >
      </el-table-column>
      <el-table-column
        prop="content"
        label="反馈内容"
      >
      </el-table-column>
      <el-table-column
        prop="realname"
        label="联系人"
      >
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="联系电话"
      >
      </el-table-column>
      <el-table-column
        prop="sub_time"
        label="提交时间"
      >
      </el-table-column>
      <el-table-column
        label="受理状态"
      >
        <template  slot-scope="scope">
          <span v-if="scope.row.is_status === 1" class="yizhiding">已受理</span>
          <span v-if="scope.row.is_status === 0" class="weitongguo">待受理</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status_time"
        label="受理情况备注"
      >
      </el-table-column>
      <el-table-column
        prop="status_time"
        label="受理时间"
      >
      </el-table-column>
      <el-table-column label="操作"  fixed="right" width="200">
        <template slot-scope="scope">
          <div class="row">
            <button  @click="Pushxiangqing(scope.row)" icon="el-icon-edit" class="sdbutton">查看详情</button>
            <button  @click="tongguoshenqing(scope.row)" icon="el-icon-delete" class="shoulifankui">受理反馈</button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="pageshow">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[10,15,20]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <vxe-modal width="336" ref="piliangtongguo" height="182" size="small" :show-footer="false" :showHeader="false" :show-close="true">
      <div class="popchuangkou">
        <img src="../../assets/img/closeaaaa.png" alt="" class="dsff" @click="plClose">
        <div class="titledd">
          是否确认批量受理?
        </div>
        <div class="bobox">
          <button class="queren" @click="plqueren">
            确认
          </button>
          <button class="quxiao"  @click="plClose">
            取消
          </button>
        </div>
      </div>
    </vxe-modal>
    <vxe-modal v-model="tongguoshow" width="336" ref="tongguo" height="182" size="small" :show-footer="false" :showHeader="false" :show-close="true">
      <div class="popchuangkou">
        <img src="../../assets/img/closeaaaa.png" alt="" class="dsff" @click="routeClose">
        <div class="titledd mbP">
          受理反馈
        </div>
        <vxe-input v-model="remark" placeholder="请输入受理情况备注(非必填)" style="width: 200px;height: 50px"></vxe-input>
        <div class="bobox">
          <button class="queren" @click="openqueren">
            确认
          </button>
          <button class="quxiao"  @click="routeClose">
            取消
          </button>
        </div>
      </div>
    </vxe-modal>
</div>
</template>

<script>
import { feedbackList, feedbackSetstatusval } from '@/api/xinxi'

export default {
  name: 'yijianfankui',
  data () {
    return {
      pageshow: true,
      cur_page: 1,
      total: null,
      tableData: [],
      tongguoshow: false,
      remark: '',
      Query: {
        token: sessionStorage.getItem('token'),
        create_date: '',
        sortby: 0,
        is_status: 0,
        keyword: '',
        page: 1,
        pagesize: 10,
        orach: null,
        NewArr: [],
        itemcc: {}
      }
    }
  },
  created () {
    this.xiangqing()
  },
  computed: {
    defaultImg () {
      return 'this.src="' + require('../../assets/img/no.jpg') + '";'
    }
  },
  methods: {
    Pushxiangqing (row) {
      // this.$store.commit('setyijianID', row.id)
      this.$router.push('/yijianfankuixiangqing?id=' + row.id)
    },
    routeClose () {
      this.$refs.tongguo.close()
      this.xiehuiList()
    },
    tongguoshenqing (item) {
      console.log('item', item)
      this.$refs.tongguo.open()
      this.itemcc = item
    },
    openqueren () {
      const obj = {
        token: sessionStorage.getItem('token'),
        ids: this.itemcc.id,
        remark: this.remark
      }
      feedbackSetstatusval(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
          this.$refs.tongguo.close()
          this.xiangqing()
        }
      })
    },
    plqueren () {
      const obj = {
        token: sessionStorage.getItem('token'),
        ids: this.orach,
        remark: ''
      }
      feedbackSetstatusval(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
          this.$refs.piliangtongguo.close()
          this.xiangqing()
        }
      })
    },
    openccsss () {
      this.$refs.piliangtongguo.open()
    },
    plClose () {
      this.$refs.piliangtongguo.close()
    },
    EdithandleSelectionChange (val) {
      console.log('val', val)
      const Arr = []
      val.forEach(i => {
        Arr.push(i.id)
        this.NewArr = [...new Set(Arr)]
        console.log('NewArr', this.NewArr)
        console.log(JSON.stringify(this.NewArr).replace(/\[|]/g, ''))
        this.orach = JSON.stringify(this.NewArr).replace(/\[|]/g, '')
      })
    },
    piliangtongguo () {

    },
    Discountsearch () {
      this.cur_page = 1
      this.xiangqing()
      this.pageshow = false// 让分页隐藏
      this.$nextTick(() => { // 重新渲染分页
        this.pageshow = true
      })
    },
    handleSizeChange (val) {
      this.query.pagesize = val
      this.handleCurrentChange(this.query.page)
    },
    handleCurrentChange (val) {
      this.query.page = val
      this.xiangqing()
    },
    xiangqing () {
      feedbackList(this.Query).then(({ data: res }) => {
        console.log('res', res)
        this.tableData = res.list
        this.total = res.total
      })
    }
  }
}
</script>

<style  lang="less">
.el-table th:nth-child(10 )>.cell {
  display: inline-block;
  box-sizing: border-box;
  position: relative;
  vertical-align: middle;
  padding-left: 10px;
  padding-right: 10px;
  width: 100%;
  text-align: center;
}
.popchuangkou{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  .mbP{
    margin-bottom: 24px;
  }
  .dsff{
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
  }
  .titledd{
    margin-top: 22px;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 500;
    text-align: left;
    color: #2e2e2e;
  }
  .einput{
    width: 253px;
    height: 44px;
    opacity: 1;
    background: #fbfbfb;
    border-radius: 5px;
  }
  .bobox{
    margin-top: 43px;
    display:flex;
    flex-direction: row;
    align-items: center;
  }
  .queren{
    width: 95px;
    height: 36px;
    opacity: 1;
    background: linear-gradient(135deg,#3d9aff, #3380f2);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    margin-right: 12px;
  }
  .quxiao{
    width: 95px;
    height: 36px;
    opacity: 1;
    background: rgba(61,154,255,0.10);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #3d9aff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
  }
}
.shoulifankui{
  width: 78px;
  height: 37px;
  opacity: 1;
  border: 1px solid rgba(15,168,56,0.50);
  border-radius: 2px;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #0fa838;
  letter-spacing: 0px;
  background: white;
}
.weizhiding{
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #0fa838;
  letter-spacing: 0px;
}
.yizhiding{
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #0fa838;
  letter-spacing: 0px;
}
.body {
  display: flex;
  flex-direction: column;

.title {
  opacity: 1;
  font-size: 30px;
  font-family: PingFang SC, PingFang SC-Heavy;
  font-weight: 800;
  text-align: left;
  color: #2e2e2e;
  letter-spacing: 0px;
  margin-bottom: 35px;
  display: flex;
  flex-direction: row;
  align-items: center;

.fansk {
  margin-top: 30px;
  margin-left: 32px;
}

.dsadf {
  color: #3D9AFF;
}
}
.btnsearch{
  display:flex;
  flex-direction: row;
  align-items: center;
.left{
  margin-right: 150px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.right{
  margin-top: 27px;
}
}
.btnss{
  width: 124px;
  height: 43px;
  opacity: 1;
  background: linear-gradient(135deg,#1bb745, #17ab3f);
  border-radius: 5px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  margin-right: 11px;
}
.jubaowuxiao{
  width: 124px;
  height: 44px;
  opacity: 1;
  background: linear-gradient(135deg,#e54848, #d54141);
  border-radius: 5px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0px;
  border:none;
  display: flex;
  justify-content: center;
  align-items: center;
}
}
</style>
